/**
 * Figma mobile artboard width for end-user app screen shells.
 * All end-user page/frame containers should use this (375px).
 */
export const END_USER_MOBILE_FRAME_WIDTH_PX = 375;
